import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class JobOrderService extends GenericService {
  constructor() {
    super('/job_orders', axiosInstance);
  }

  async getFGItems(jobOrderId) {
    try {
      const response = await axiosInstance.get(`${this.baseUrl}/${this.encodePathSegment(jobOrderId)}/fg_items`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getJobCostings(jobOrderId) {
    try {
      const response = await axiosInstance.get(`${this.baseUrl}/${this.encodePathSegment(jobOrderId)}/job_costings`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async addAdvancePayment(id, data) {
    try {
      const response = await axiosInstance.post(`${this.baseUrl}/${this.encodePathSegment(id)}/advance_payment`, data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async reverse(id) {
    try {
      const response = await axiosInstance.post(`${this.baseUrl}/${this.encodePathSegment(id)}/reverse`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new JobOrderService(); 